/**
 * Parse les datetime renvoyés par NoCodeBackend / MySQL (souvent sans fuseau explicite).
 * Sans suffixe Z ou ±hh:mm, on les interprète en UTC : affichage correct en heure locale (ex. fr-FR).
 */
export function parseBackendUtcToDate(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;

  if (/[zZ]$/.test(s) || /[+-]\d{2}:?\d{2}$/.test(s)) {
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const withTime = /^(\d{4}-\d{2}-\d{2})[ T](\d{1,2}:\d{2}(?::\d{2})?(?:\.\d{1,6})?)$/.exec(s);
  if (withTime) {
    const d = new Date(`${withTime[1]}T${withTime[2]}Z`);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const dateOnly = /^(\d{4}-\d{2}-\d{2})$/.exec(s);
  if (dateOnly) {
    const d = new Date(`${dateOnly[1]}T00:00:00Z`);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}
